/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }          from 'react';
import { useField }    from 'formik';
import { Label }       from '~/components/label';
import { SelectProps }  from './types';
import { styles }      from './styles';

export const Select: FC<SelectProps> = ({ name, label, format, description, ...props }) => {
  const [field, meta] = useField({ ...props, name });

  return (
    <label css={styles.container}>
      {label && <Label info={description}>{label}</Label>}

      <div css={styles.wrapper}>
        <select
          {...field}
          {...props}
          css={[
            styles.input,
            styles.states.default,
            meta.touched && meta.error && styles.states.error,
            format && { paddingRight: 44 }
          ]}
        />
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" css={styles.arrow}>
          <path fillRule="evenodd" clipRule="evenodd" d="M20 8.71 12 17 4 8.71 4.71 8 12 15.55 19.29 8z" fill="currentColor" />
        </svg>
      </div>

      {meta.touched && meta.error && <span css={styles.error}>{meta.error}</span>}
    </label>
  );
};
